import React, { useState, useEffect } from 'react';
import QuoteBuilderForm from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderForm.jsx';

const Printing = ({ config, disabled, options, uuid, item, extra_item_title, navSection, colIndex, rowIndex, getExtraItems, disabledReason, navSectionColumnType }) => {
  return (
      <QuoteBuilderForm
        config={config.printing}
        disabled={disabled}
        disabledReason={disabledReason}
        options={options}
        section_uuid={uuid}
        navSectionColumnType={navSectionColumnType}
        item={item}
        extra_title={extra_item_title}
        getExtraItems={getExtraItems}
        navSection={navSection}
        colIndex={colIndex}
        rowIndex={rowIndex}
      />
  )
}

export default Printing;
